import { SliceProps } from "@/Slice/index"
import { CTA, GRichText } from "@/components"
import { BannerSlot } from "@jog/react-components"
import { containerSlot, imageSizes } from "@jog/shared"
import classNames from "classnames"

const sizeMap = {
    big: { sm: "100vw", ...containerSlot(2) },
    small: { sm: "50vw", ...containerSlot(4) },
}
const sizeFullMap = {
    big: { sm: "100vw", lg: "50vw" },
    small: { sm: "50vw", lg: "25vw" },
}
export const FiveSlotBanner = ({
    slice: { primary, items },
    className,
    full,
    lcp,
}: SliceProps<"five_slot_banner"> & { full?: boolean; lcp: boolean }) => {
    return (
        <div className={classNames(className, "grid grid-cols-1 gap-0.5 lg:grid-cols-2")}>
            <div>
                <BannerSlot
                    link={primary.primary_button_url}
                    text={primary.text}
                    textAlignment={primary.text_alignment}
                    textColor={primary.text_color}
                    textTopPosition={primary.text_top_position}
                    buttonText={primary.primary_button_label}
                    buttonTopPosition={primary.primary_button_top_position || 0}
                    buttonBgColor={primary.buttons_bg_color || ""}
                    buttonTextColor={primary.buttons_text_color || ""}
                    colorHover={primary.buttons_hover_text_color || ""}
                    bgColorHover={primary.buttons_hover_bg_color || ""}
                    borderWidth={primary.buttons_border_width || 0}
                    borderColor={primary.buttons_border_color || ""}
                    fontSizeMobile={primary.buttons_font_size_mobile || ""}
                    sizes={imageSizes(full ? sizeFullMap.big : sizeMap.big)}
                    image={primary.primary_banner_image_desktop}
                    RichText={GRichText}
                    CTA={CTA}
                    lcp={lcp}
                />
            </div>
            <div className="grid h-full w-full grid-cols-2 gap-0.5">
                {items.map((item, index) => (
                    <div key={index}>
                        <BannerSlot
                            link={item.button_url}
                            text={primary.text}
                            textAlignment={primary.text_alignment}
                            textColor={primary.text_color}
                            textTopPosition={primary.text_top_position_for_secondary}
                            buttonText={item.button_label}
                            buttonTopPosition={primary.secondary_buttons_top_position || 0}
                            buttonBgColor={primary.buttons_bg_color || ""}
                            buttonTextColor={primary.buttons_text_color || ""}
                            colorHover={primary.buttons_hover_text_color || ""}
                            bgColorHover={primary.buttons_hover_bg_color || ""}
                            borderWidth={primary.buttons_border_width || 0}
                            borderColor={primary.buttons_border_color || ""}
                            fontSizeMobile={primary.buttons_font_size_mobile || ""}
                            sizes={imageSizes(full ? sizeFullMap.small : sizeMap.small)}
                            image={item.image}
                            RichText={GRichText}
                            CTA={CTA}
                            lcp={lcp}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
